import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-radar-chart',
	templateUrl:'./RadarChartPluginCompPage.html',
	styles: [],
	styleUrls:['./RadarChartPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class RadarChartPluginCompPage
{
	mdContent_1093 = `\`\`\`java
import com.jwebmp.plugins.chartjs.RadarChart;
\`\`\``;
	mdContent_1094 = `\`\`\`java
RadarChart(RadarData data)
\`\`\``;
	mdContent_1095 = `\`\`\`java
RadarDataset ds1 = new RadarDataset()
    .setLabel("Team A").setData(65, 59, 90, 81, 56);
RadarDataset ds2 = new RadarDataset()
    .setLabel("Team B").setData(28, 48, 40, 19, 96);
RadarData data = new RadarData()
    .addLabels("Speed", "Power", "Skill", "Stamina", "Luck")
    .addDataset(ds1).addDataset(ds2);
\`\`\``;
}
